/**
 * Affirm payment method - uses shared BNPL factory.
 */

import {
  type BnplCheckoutResponse,
  type BnplCustomerInfo,
  type BnplSubmitOptions,
  createBnplPaymentMethod,
} from "./bnpl-shared";

export type AffirmCustomerInfo = BnplCustomerInfo;

export type AffirmSubmitOptions = Omit<BnplSubmitOptions, "setupFutureUsage">;

export type AffirmCheckoutResponse = BnplCheckoutResponse;

const AffirmPaymentMethod = createBnplPaymentMethod({
  name: "affirm",
  endpointPath: "affirm",
  supportsSetupFutureUsage: false,
});

export default AffirmPaymentMethod;
